import { API_URL } from 'consts/common.const';
import { Http } from 'services/http';
type TypeExecuteCache = 'update_master-cache' | 'clear_master_cache';
export const executeCache = (executeCache: TypeExecuteCache) => {
  return Http.request({
    method: 'GET',
    url: `${API_URL}/masterdata/${executeCache}`,
  });
};
